export type AccountLanguage = "en" | "ko";

export const isAccountLanguage = (value: unknown): value is AccountLanguage =>
    value === "en" || value === "ko";
